<template>
  <v-theme-provider light>
    <v-container fluid class="section-about-company py-12 grey lighten-4 grey--text text--darken-3" id="section-about-company">
      <v-row class="display-1 font-weight-medium">
        <v-col md="8" offset-md="2">
          <p class="text-center"><v-icon class="blink" color="primary">mdi-color-helper</v-icon>About us</p>
          <p class="title pt-10">Our Story</p>
          <p class="subtitle-1" style="text-align:justify">
            At PatrOwl, we believe there is a better way to anticipate cyber threats. We just focus on what matters: find the vulnerabilities before bad guys exploit them.
          </p>
          <p class="subtitle-1" style="text-align:justify">
            The idea for PatrOwl was born in 2018 when, as pentesters we wanted to automate most recon steps as possible. Penetration tests have to be performed in a limited timeframe on a highly mixed perimeter. First steps are automated then manual testing follows. So, security staffs use and build tools. Lots of tools, with different policies. As experienced guys, we had a golden .txt file with all commands to start the scanners with the right parameters. We were bored of this work habits and looked for efficiency and a way to perform these scans continuously.<br/>

            Working closely with a mature SOC, the objective was to build a single cockpit to manage our monitored assets, the scanning policies already packaged and all findings issued by our security tools. Only few adjustments where necessary to be able for consuming data from others security scanners, cyber-threat intelligence feeds to cover other cybersecurity domains like vulnerability management, secure CI/CD, phishing preparation, Data leakage, Compliance,... It was a technical win.<br/>

            PatrOwl was immediatly released open-source. Several people tried it, gave us feedbacks and started to contribute ! We had opportunities to talk about PatrOwl and its core concepts of SecOps automation at various security conferences. It was both a personal and a business win.
          </p>
          <p class="title pt-3">Our (awesome) Team</p>
          <p class="subtitle-1" style="text-align:justify">
            PatrOwl's commercial company was founded in 2020 by security experts with a common objective: to offer tools and expertise for managing cyber threats efficiently, while contributing to the open-source comunity.<br/>
            We build tools and provide security services. We strongly believe that one does not go without the other if we want to continue to keep us updated of Enterprise concerns and threats evolutions. Meet the founders, they do not talk about IA based on if-then-else statements:
          </p>

        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col
          v-for="(item, i) in team.founders"
          :key="i"
          cols="auto"
          >
          <v-card dark>
            <div class="d-flex flex-wrap justify-space-between">

              <v-avatar
                class="ma-3"
                size="150"
                tile
              >
                <v-img :src="item.avatar" contain></v-img>
              </v-avatar>
              <div>
                <v-card-title
                  class="title"
                  v-text="item.name"
                ></v-card-title>
                <v-card-subtitle v-text="item.position"></v-card-subtitle>

                <v-card-text align="center">
                  <v-btn
                    v-if="item.linkedin"
                    text icon
                    :href="item.linkedin" target="_blank">
                    <v-icon>mdi-linkedin</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="item.twitter"
                    text icon
                    :href="item.twitter" target="_blank">
                    <v-icon>mdi-twitter</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="item.github"
                    text icon
                    :href="item.github" target="_blank">
                    <v-icon>mdi-github</v-icon>
                  </v-btn>
                </v-card-text>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col
          v-for="(item, i) in team.employees"
          :key="i"
          cols="auto"
          >
          <v-card dark>
            <div class="d-flex flex-wrap justify-space-between">

              <v-avatar
                class="ma-3"
                size="150"
                tile
              >
                <v-img :src="item.avatar" contain></v-img>
              </v-avatar>
              <div>
                <v-card-title
                  class="title"
                  v-text="item.name"
                ></v-card-title>
                <v-card-subtitle v-text="item.position"></v-card-subtitle>

                <v-card-text align="center">
                  <v-btn
                    v-if="item.linkedin"
                    text icon
                    :href="item.linkedin" target="_blank">
                    <v-icon>mdi-linkedin</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="item.twitter"
                    text icon
                    :href="item.twitter" target="_blank">
                    <v-icon>mdi-twitter</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="item.github"
                    text icon
                    :href="item.github" target="_blank">
                    <v-icon>mdi-github</v-icon>
                  </v-btn>
                </v-card-text>
              </div>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-theme-provider>
</template>

<script>
export default {
  name: "SecAboutCompany",
  data: () => ({
    team: {
      founders: [
        { name: 'Nicolas MATTIOCCO',
          position: 'CEO, Security Expert',
          github: 'https://github.com/MaKyOtOx',
          twitter: 'https://twitter.com/MaKyOtOx',
          linkedin: 'https://www.linkedin.com/in/nicolasmattiocco',
          avatar: require('@/assets/avatars/nicolas.mattiocco.jpg')
        },
        { name: 'Vladimir KOLLA',
          position: 'COO, Security Expert',
          twitter: 'https://twitter.com/mynameisv_',
          linkedin: 'https://www.linkedin.com/in/vlad-k-3517a064/',
          avatar: require('@/assets/img/patrowl-logo-white.png')
        },
        { name: 'Florent MONTEL',
          position: 'CTO, Security Expert',
          github: 'https://github.com/Pepitoh',
          twitter: 'https://twitter.com/Pepito_oh',
          linkedin: 'https://www.linkedin.com/in/florent-montel-3a292243/',
          avatar: require('@/assets/avatars/florent.montel.jpg')
        },
      ],
      employees: [
        { name: 'Baptiste',
          position: 'DevOps & SRE',
          // linkedin: 'https://www.linkedin.com/in/bdoublet/',
          avatar: require('@/assets/img/patrowl-logo-white.png')
        },
        { name: 'Sébastien',
          position: 'Security Engineer',
          // linkedin: 'https://www.linkedin.com/in/s%C3%A9bastien-coll-19399179/',
          avatar: require('@/assets/img/patrowl-logo-white.png')
        },
        { name: 'Victor',
          position: 'VueJS Frontend Developer',
          // linkedin: 'https://www.linkedin.com/in/victor-paoli/',
          avatar: require('@/assets/img/patrowl-logo-white.png')
        },
        { name: 'Porus',
          position: 'Python Backend Developer',
          // linkedin: 'https://www.linkedin.com/in/victor-paoli/',
          avatar: require('@/assets/img/patrowl-logo-white.png')
        },
        { name: 'Romaric',
          position: 'Head of Sales',
          // linkedin: 'https://www.linkedin.com/in/victor-paoli/',
          avatar: require('@/assets/img/patrowl-logo-white.png')
        },
        { name: 'Marilou',
          position: 'Marketing',
          // linkedin: 'https://www.linkedin.com/in/victor-paoli/',
          avatar: require('@/assets/img/patrowl-logo-white.png')
        },
        { name: 'Loan',
          position: 'Marketing',
          // linkedin: 'https://www.linkedin.com/in/victor-paoli/',
          avatar: require('@/assets/img/patrowl-logo-white.png')
        },
        { name: 'Marius',
          position: 'Security Engineer + Pentester',
          // linkedin: 'https://www.linkedin.com/in/victor-paoli/',
          avatar: require('@/assets/img/patrowl-logo-white.png')
        },
        { name: 'Yohan',
          position: 'Security Engineer + Pentester',
          // linkedin: 'https://www.linkedin.com/in/victor-paoli/',
          avatar: require('@/assets/img/patrowl-logo-white.png')
        },
      ]
    }
  })
};
</script>
